module.exports = __webpack_public_path__ + "img/design-preview.83be0415.jpg";